import { render, staticRenderFns } from "./BadgeCreate.vue?vue&type=template&id=111325e0&"
import script from "./BadgeCreate.vue?vue&type=script&lang=ts&"
export * from "./BadgeCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports